import React from "react";
import PVReviewIndex from "../../sub-treasury/pv-collection/PVReviewIndex";

const MdaReviewPV = () => {
  return <PVReviewIndex mdaType="self-sustaining" mode="review" />;
};
export default MdaReviewPV;
